<div class="col-sm-12">
  <div class="col-sm-12">
    <h4 class="modal-title pull-left">{{ "StrategyOne Deployement Details" | translate }}</h4>
  </div>
  <div class="col-sm-12">
    <br />
    <hr>
    </div>
    <div class="col-sm-12">
      <appspinner [startSpinner]="showAppLoader"></appspinner>
      <h6 class="text-danger text-with-newlines" translate="">{{errorMessage}}</h6>
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="col-sm-12">
          <div class="accordion" id="workspaceInfo">
            <div class="card">
              <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                data-parent="#accordionExample">
                <div class="card-body">
                  <div class='col-md-12'>
                    <div class="row">
                      <div class="col-sm-3">
                        <h5>Version</h5>
                      </div>
                      @if (isEnableEndpoints && s1StandardInfo) {
                        <div class="col-sm-9">
                          <span class="col-sm-12">{{s1StandardInfo.version}}</span>
                        </div>
                      }
                    </div>
                  </div>
                  <hr>
                    <div class="col-sm-12">
                      <div class="row">
                        <div class="col-sm-3">
                          <h5>Workspace Path</h5>
                        </div>
                        <div class="col-sm-9">
                          @if (s1StandardInfo) {
                            <span class="col-sm-12">
                              {{s1StandardInfo.workspacePath}}
                            </span>
                          }
                          @if (s1StandardInfo && s1StandardInfo.loadedFlag) {
                            <button [disabled]="true" class="btn btn-sm btn-success pull-right"
                              >
                              Loaded
                            </button>
                          }
                          @if (!isEnableEndpoints || (s1StandardInfo && !s1StandardInfo.loadedFlag)) {
                            <button [disabled]="true" class="btn btn-sm btn-danger pull-right"
                              >
                              Not Loaded
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12"><br /></div>
            <div class="accordion" id="endPointInfo">
              <div class="card">
                <div class="card-header">
                  <h5 class="mb-0">
                    Endpoints
                  </h5>
                </div>
                <div>
                  <div class="card-body">
                    <div class="col-sm-12">
                      <div class="row">
                        <div class="col-sm-3">
                          <h5>Soap Public</h5>
                        </div>
                        @if (isEnableEndpoints) {
                          <div class="col-sm-9">
                            <span class="col-sm-12">{{s1StandardInfo.soapPublic}}</span>
                            <a href="{{envURL}}S1Public?wsdl" target="_blank"
                            class="btn btn-sm btn-primary pull-right">WSDL</a>
                          </div>
                        }
                      </div>
                    </div>
                    <hr>
                      <div class="col-sm-12">
                        <div class="row">
                          <div class="col-sm-3">
                            <h5>Soap Private</h5>
                          </div>
                          @if (isEnableEndpoints) {
                            <div class="col-sm-9">
                              <span class="col-sm-12">{{s1StandardInfo.soapPrivate}}</span>
                              <a href="{{envURL}}S1Private?wsdl" target="_blank"
                              class="btn btn-sm btn-primary pull-right">WSDL</a>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>